import styled from 'styled-components';
import { Image as ImageComponent } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const ButtonShowImage = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 14px;
    margin: 0 10px;
    width: 50%;
  }

  @media (max-width: 1199px) {
      &.ui.button {
      margin: 0 0 0 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const CentralizedQuestionLabel = styled.h2`
  text-align: center;
  padding-top: 0px;
`;

export const Image = styled(ImageComponent)`
  pointerEvents: none;
`;

export const ImageBlank = styled.div`
  background-color: #F8F8F8;
  align-self:center;
  width: 500px;
  height: 337px;
  border-radius: 4px;
`;
